import React from 'react';
import { Box, Chip, CircularProgress, Paper, Typography } from '@mui/material';
import { WhatsAppTemplate } from './types';

interface Props {
  template: WhatsAppTemplate | null;
  preview?: string;
  loading?: boolean;
}

const TemplatePreviewPanel: React.FC<Props> = ({ template, preview, loading = false }) => {
  if (loading) {
    return (
      <Paper sx={{ p: 2, minHeight: 200, display: 'flex', alignItems: 'center', gap: 1.5 }}>
        <CircularProgress size={22} />
        <Typography color="text.secondary">Loading template preview...</Typography>
      </Paper>
    );
  }

  if (!template) {
    return (
      <Paper sx={{ p: 2, minHeight: 200 }}>
        <Typography color="text.secondary">Select a template to preview</Typography>
      </Paper>
    );
  }

  return (
    <Paper sx={{ p: 2 }}>
      <Typography variant="h6" gutterBottom>{template.name}</Typography>
      <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', mb: 2 }}>
        <Chip size="small" label={template.provider.toUpperCase()} />
        {template.category && <Chip size="small" label={template.category} color="primary" variant="outlined" />}
        <Chip size="small" label={template.language} variant="outlined" />
        <Chip size="small" label={template.approval_status} color="success" variant="outlined" />
      </Box>
      <Typography variant="subtitle2" color="text.secondary" gutterBottom>
        Message preview
      </Typography>
      <Paper variant="outlined" sx={{ p: 2, mb: 2, bgcolor: '#f5f5f5', whiteSpace: 'pre-wrap' }}>
        {preview || template.body_text || 'No body text available'}
      </Paper>
      <Typography variant="body2" color="text.secondary">
        Last used: {template.last_used_at ? new Date(template.last_used_at).toLocaleString() : 'Never'}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        Content ID: {template.external_id}
      </Typography>
    </Paper>
  );
};

export default TemplatePreviewPanel;
